module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-01.a51bca71.jpg";